import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";
import { t } from "ttag";

import { Button } from "@/shared/ui";
import type { ButtonProps } from "@/shared/ui";

const navigationButtonsVariants = tv({
  slots: {
    root: "flex w-full flex-col-reverse items-center gap-4 pb-8 sm:flex-row sm:justify-between sm:gap-4 md:pb-20",
    cancelButton: "w-full sm:w-fit sm:min-w-32",
    nextButton: "w-full sm:ml-auto sm:w-fit sm:min-w-32",
  },
});

type NavigationButtonsProps = VariantProps<typeof navigationButtonsVariants> & {
  onCancel?: () => void;
  onContinue: () => void;

  continueLabel?: string;
  continueDisabled?: boolean;
  continueForm?: ButtonProps["form"];
  continueType?: ButtonProps["type"];
  cancelLabel?: string;
};

/**
 * @deprecated use the new `Layout.Footer` component
 */

export const LegacyNavigationButtons = ({
  onCancel,
  onContinue,
  continueLabel = t`Next`,
  continueDisabled,
  continueForm,
  continueType = "button",
  cancelLabel = t`Back`,
}: NavigationButtonsProps) => {
  const { root, cancelButton, nextButton } = navigationButtonsVariants();

  return (
    <div className={root()}>
      {onCancel && (
        <Button
          onClick={onCancel}
          variant="secondary"
          size="lg"
          className={cancelButton()}
        >
          {cancelLabel}
        </Button>
      )}

      <Button
        disabled={continueDisabled}
        onClick={onContinue}
        size="lg"
        className={nextButton()}
        type={continueType}
        form={continueForm}
      >
        {continueLabel}
      </Button>
    </div>
  );
};
